import { CRMIntegration } from '@alucio/aws-beacon-amplify/src/models';
import { ExternalOidcVaultCrmSsoConfig } from './types';

type ExternalOidcVaultCrmSsoTenantConfig = CRMIntegration['externalOidcSso'];

const DEFAULT_SCOPE = 'openid profile email';

const getAuthorizationEndpoint = (
  config: NonNullable<ExternalOidcVaultCrmSsoTenantConfig>,
): string => {
  if (config.authorizationEndpoint) {
    return config.authorizationEndpoint;
  }

  if (config.tokenEndpoint?.endsWith('/oauth2/token')) {
    return config.tokenEndpoint.replace(/\/oauth2\/token$/, '/oauth2/authorize');
  }

  if (config.tokenEndpoint?.endsWith('/protocol/openid-connect/token')) {
    return config.tokenEndpoint.replace(
      /\/protocol\/openid-connect\/token$/,
      '/protocol/openid-connect/auth',
    );
  }

  throw new Error('External OIDC authorization endpoint is not configured for this tenant.');
};

export const getExternalOidcVaultCrmSsoConfig = (
  externalOidcSso?: ExternalOidcVaultCrmSsoTenantConfig | null,
): ExternalOidcVaultCrmSsoConfig => {
  if (
    !externalOidcSso?.issuer ||
    !externalOidcSso.tokenEndpoint ||
    !externalOidcSso.clientId ||
    !externalOidcSso.redirectUri
  ) {
    throw new Error('External OIDC SSO is not configured for this tenant.');
  }

  return {
    authorizationEndpoint: getAuthorizationEndpoint(externalOidcSso),
    clientId: externalOidcSso.clientId,
    redirectUri: externalOidcSso.redirectUri,
    scope: externalOidcSso.scope || DEFAULT_SCOPE,
  };
};
